var extractParams = require('./lib/extractParams');
var extractParamsInFirstMatch = require('./lib/extractParamsInFirstMatch');

module.exports = {
  extractParams: extractParams,
  extractParamsInFirstMatch: extractParamsInFirstMatch
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/extract-params/index.js
 ** module id = 525
 ** module chunks = 0
 **/